import { Type, Transform } from 'class-transformer';
import { EOrientation } from "../../../core/EOrientation";
import { EJoinType } from "../../../core/FrontElementParameter/EJoinType";
import { DrawCabinetFrontElement } from "./DrawCabinetFrontElement";
import { DrawFrontDoor } from './DrawFrontDoor';
import { DrawFrontDrawer } from './DrawFrontDrawer';
import { DrawFrontEmpty } from './DrawFrontEmpty';
import { DrawFrontFrame } from './DrawFrontFrame';
import { DrawFrontHorizontalGroove } from './DrawFrontHorizontalGroove';
import { DrawFrontPanel } from './DrawFrontPanel';
import { DrawFrontPullOut } from './DrawFrontPullOut';
import { DrawFrontShutter } from './DrawFrontShutter';

export class DrawCabinetFrontElementGroup extends DrawCabinetFrontElement {
    Orientation: EOrientation = EOrientation.Vertical;
    JoinType: EJoinType = EJoinType.N;

    @Type(() => DrawCabinetFrontElement, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: 'TypeName',
            subTypes: [
                { value: DrawCabinetFrontElement, name: 'DrawCabinetFrontElement' },
                { value: DrawCabinetFrontElementGroup, name: 'DrawCabinetFrontElementGroup' },
                { value: DrawFrontDoor, name: 'DrawFrontDoor' },
                { value: DrawFrontDrawer, name: 'DrawFrontDrawer' },
                { value: DrawFrontEmpty, name: 'DrawFrontEmpty' },
                { value: DrawFrontFrame, name: 'DrawFrontFrame' },
                { value: DrawFrontHorizontalGroove, name: 'DrawFrontHorizontalGroove' },
                { value: DrawFrontPanel, name: 'DrawFrontPanel' },
                { value: DrawFrontPullOut, name: 'DrawFrontPullOut' },
                { value: DrawFrontShutter, name: 'DrawFrontShutter' },
            ],
        },
    })
    Elements: DrawCabinetFrontElement[] = [];

    constructor() {
        super();
        this.Elements = [];
    }

    toFlatHierarchy(): DrawCabinetFrontElement[] {
        let flatHierarchy: DrawCabinetFrontElement[] = [this];

        for (const childElement of this.Elements) {
            flatHierarchy = flatHierarchy.concat(childElement.toFlatHierarchy());
        }

        return flatHierarchy;
    }

    groupToFlatHierarchy(): DrawCabinetFrontElementGroup[] {
        let flatHierarchy: DrawCabinetFrontElementGroup[] = [this];

        for (const element of this.Elements) {
            if (element instanceof DrawCabinetFrontElementGroup) {
                flatHierarchy = flatHierarchy.concat(element.groupToFlatHierarchy());
            }
        }

        return flatHierarchy;
    }

    findParentOf(searchedChild: DrawCabinetFrontElement): DrawCabinetFrontElementGroup | null {
        if (this.Elements.includes(searchedChild)) {
            return this;
        }

        for (const element of this.Elements) {
            if (element instanceof DrawCabinetFrontElementGroup) {
                const parent = element.findParentOf(searchedChild);
                if (parent) {
                    return parent;
                }
            }
        }

        return null;
    }
}
